import { createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatcher } from "../../utils/useDispatcher";
import {
  getLoanRequests,
  getLoanRequest,
  approveLoanRequest,
  rejectLoanRequest,
} from "../../services/loanRequestService";

export const doGetLoanRequests = createAsyncThunk(
  "loanRequest/doGetLoanRequests",
  async ({ groupId, status }, { rejectWithValue }) => {
    try {
      const data = await getLoanRequests(groupId, status);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch loan requests");
    }
  }
);

export const doGetLoanRequest = createAsyncThunk(
  "loanRequest/doGetLoanRequest",
  async (id, { rejectWithValue }) => {
    try {
      const data = await getLoanRequest(id);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch loan request");
    }
  }
);

export const doApproveLoanRequest = createAsyncThunk(
  "loanRequest/doApproveLoanRequest",
  async (id, { rejectWithValue }) => {
    try {
      const data = await approveLoanRequest(id);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message || "Failed to approve loan request" }
      );
    }
  }
);

export const doRejectLoanRequest = createAsyncThunk(
  "loanRequest/doRejectLoanRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await rejectLoanRequest(payload);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message || "Failed to reject loan request" }
      );
    }
  }
);

export const useGetLoanRequests = () => useDispatcher(doGetLoanRequests);
export const useGetLoanRequest = () => useDispatcher(doGetLoanRequest);
export const useApproveLoanRequest = () => useDispatcher(doApproveLoanRequest);
export const useRejectLoanRequest = () => useDispatcher(doRejectLoanRequest);
